import { useState } from "react";
import { STATIC_STRINGS } from "@asez/shared";
import FilterList from "@mui/icons-material/FilterList";
import CloseIcon from "@mui/icons-material/Close";
import Menu from "@mui/material/Menu";
import Tooltip from "@mui/material/Tooltip";
import { FILTER_KEYS } from "@asez/shared";
import { FiltersType } from "../../types";
import { MarksFilter } from "./MarksFilter";
import { TrustFilter } from "./TrustFilter";
import { ProgressFilter } from "./ProgressFilter";
import { StatusFilter } from "./StatusFilter";
import { AreasFilter } from "./AreasFilter";
import useMediaQueryScreen from "../../../../../hooks/useMediaQueryScreen";

export const initialFilters: FiltersType = {
  [FILTER_KEYS.MARKS]: [0, 100],
  [FILTER_KEYS.PROGRESS_STATUS]: "",
  [FILTER_KEYS.USER_STATUS]: "",
  [FILTER_KEYS.TRUST_SCORE]: [0, 100],
  [FILTER_KEYS.STRONG_AREAS]: [],
};

export const FilterMenu = ({ applyFilters }) => {
  const [filterAnchorEl, setFilterAnchorEl] = useState<null | HTMLElement>(
    null
  );
  const [filters, setFilters] = useState<FiltersType>(initialFilters);
  const { screen, screenProps } = useMediaQueryScreen();

  const updateFilters = <K extends FILTER_KEYS>(
    key: K,
    value: FiltersType[K]
  ) => {
    setFilters((prevFilters) => ({ ...prevFilters, [key]: value }));
  };

  const handleResetAll = () => {
    setFilters({ ...initialFilters });
    setFilterAnchorEl(null);
    applyFilters({}, true);
  };

  const handleApply = () => {
    applyFilters(filters);
    setFilterAnchorEl(null);
  };

  return (
    <>
      <Tooltip title={STATIC_STRINGS.TOOLTIP_MESSAGES.SHOW_FILTERS}>
        <button
          className="btn btn-outline button-padding p-1 flex items-center justify-center text-neutral-dark"
          onClick={(e) => setFilterAnchorEl(e.currentTarget)}
        >
          <FilterList
            fontSize={!screenProps.is_largeplus ? "small" : "medium"}
          />
        </button>
      </Tooltip>
      <Menu
        anchorEl={filterAnchorEl}
        open={Boolean(filterAnchorEl)}
        onClose={() => setFilterAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <div className="w-96 p-2">
          <div
            className="w-full pb-2 border-b-2 border-b-neutral-dark/50"
            onClick={() => setFilterAnchorEl(null)}
          >
            <div className="w-80 mx-auto flex justify-between items-center">
              <div className="font-semibold flex justify-center items-center">
                <div className="text-neutral-dark mr-1">
                  <FilterList fontSize="medium" />
                </div>
                {STATIC_STRINGS.FILTERS}
              </div>
              <CloseIcon className="cursor-pointer hover:text-neutral-dark" />
            </div>
          </div>

          <MarksFilter filters={filters} updateFilters={updateFilters} />
          <ProgressFilter filters={filters} updateFilters={updateFilters} />
          <StatusFilter filters={filters} updateFilters={updateFilters} />
          <TrustFilter filters={filters} updateFilters={updateFilters} />
          <AreasFilter filters={filters} updateFilters={updateFilters} />

          <div className="w-full">
            <div className="w-80 mx-auto flex justify-between items-center pt-2">
              <button
                className="btn btn-outline px-2 py-1"
                onClick={handleResetAll}
              >
                {STATIC_STRINGS.RESET_ALL}
              </button>
              <button
                className="btn btn-primary px-3 py-1 border-2 border-neutral-dark"
                onClick={handleApply}
              >
                {STATIC_STRINGS.APPLY}
              </button>
            </div>
          </div>
        </div>
      </Menu>
    </>
  );
};
